module.exports = __webpack_public_path__ + "img/stat_basic_ru_mobile.d76411ac.png";